import Icon from '@mui/material/Icon';
import React, { useEffect, useState } from 'react';
import { Button, Badge, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
import Search from '../assets/Search.svg';
import Close from '../assets/delete.svg';
import ConfigHandler from '../config';
import '../scss/views/NewQuote.scss';
import { RestService } from '../utils';
import { AuthHandler } from '../utils/AuthHandler';
import Utils from '../utils/Utils';
import QuoteCoverageTable from './QuoteCoverageTable';

const QuoteSite = ({ keyID, removeSite, addSite, calculateTotal, editingMode, datas, view, quoteID, partner }) => {
  const [locationMethod, setLocationMethod] = useState('address');
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedStreet, setSelectedStreet] = useState(null);
  const [hasBuildingNumbers, setHasBuildingNumbers] = useState(false);
  const [selectedStreetNumber, setSelectedStreetNumber] = useState(null);
  const [selectedBuildingNumber, setSelectedBuildingNumber] = useState({ civico: "", scala: "" });
  const [validated, setValidated] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [tableParams, setTableParams] = useState({ comune: null, istat: null, pk: null, part_top: null, strada: null, egon: null, civico: null, scala: null });
  const [listData, setListData] = useState(null);
  const [origData, setOrigData] = useState(null);
  const [origLevels, setOrigLevels] = useState(null);
  const { t } = useTranslation();

  const [activeFilters, setActiveFilters] = useState({ level1: [], level2: [] });
  const [levelTouched, setLevelTouched] = useState({ level1: false, level2: false });

  const toggleFilter = (level, value) => {
    if (levelTouched[level]) {
      setActiveFilters(prevState => {
        const _old = prevState[level] || [];
        const _new = _old.includes(value)
          ? _old.filter(item => item !== value)
          : [..._old, value];
        return { ...prevState, [level]: _new };
      });
    } else {
      setLevelTouched(prevState => ({ ...prevState, [level]: true }));
      setActiveFilters(prevState => ({ ...prevState, [level]: [value] }));
    }
  };

  let debounceMunicipality = null;
  let debounceStreets = null;

  let dataReturn = {};

  useEffect(() => { resetFields(); }, [partner])

  useEffect(() => {
    if (origData && origData.length > 0) {
      const filteredData = origData.map(item => {
        const filteredListino = item.listino.filter(price => {
          return activeFilters?.level1?.includes(price?.level?.[1]) && activeFilters?.level2?.includes(price?.level?.[2]);
        });
        return { ...item, listino: filteredListino };
      }).filter(item => item.listino.length > 0);
      console.log("origData", filteredData);
      console.log("levelTouched", levelTouched);
      console.log("activeFilters", activeFilters);
      console.log("filteredData", filteredData);
      setListData(filteredData);
    } else {
      console.log("filteredData", 'none');
      setListData([]);
    }
    if ((levelTouched['level1']) && (activeFilters.level1.length == 0)) {
      setLevelTouched(prevState => ({ ...prevState, level1: false }));
      setActiveFilters(prevState => ({ ...prevState, level1: origLevels?.[1] }));
    }
    if ((levelTouched['level2']) && (activeFilters.level2.length == 0)) {
      setLevelTouched(prevState => ({ ...prevState, level2: false }));
      setActiveFilters(prevState => ({ ...prevState, level2: origLevels?.[2] }));
    }
  }, [activeFilters, origData, levelTouched, activeFilters])

  useEffect(() => {
    if (view === undefined || view === null) { view = false; }
    if (editingMode) {
      if (datas != undefined) {
        console.error('***DATAS***');
        console.error(datas);
        setIsLoadingContent(true);
        setSelectedCity({ pk: datas.egonCode, nome: datas.city, cod_comune_alfa: datas.istatCode, codiceIstat: datas.istatCode });
        const parti = datas.street.split(' ');
        setSelectedStreet({ part_top: parti[0], strada: parti.slice(1).join(' '), indirizzo: datas.street, codiceEgon: '' });
        setSelectedStreetNumber({ civico: datas.streetNumber });
        setSelectedBuildingNumber({ civico: datas.streetNumber, scala: datas.buildingNumber });
        var buttonToClick = document.getElementById(`searchBut-${keyID}`);
        setTimeout(`document.getElementById('searchBut-${keyID}').click()`, 500);
        if (view) {
          setTimeout(`document.getElementById('searchBut-${keyID}').disabled = true`, 600);
        }
      }
    }
  }, [editingMode, datas, view, keyID]);

  useEffect(() => {
    if (origData) {
      const levelMap = {};
      origData.forEach(servizio => {
        servizio.listino.forEach(item => {
          item.level.forEach((v, k) => {
            if (!levelMap[k]) levelMap[k] = new Set();
            levelMap[k].add(v);
          });
        });
      });
      const newLevels = Object.keys(levelMap).map(key => Array.from(levelMap[key]));
      setOrigLevels(newLevels);
      setActiveFilters({ level1: newLevels?.[1], level2: newLevels?.[2] });
    }
  }, [origData]);

  useEffect(() => {
    //console.log(origLevels);
    localStorage.removeItem(`SITE-${keyID}`);
    localStorage.removeItem(`SITE-SELECTED-${keyID}`);
    calculateTotal();
  }, [origLevels, listData]);

  //Custom Styles for React-Select
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      border: '1px solid  rgb(168, 168, 168)',
      alignText: 'left !important',
    }),
    control: (base, state) => ({
      ...base,
      boxShadow: 'none',
      border: state.isFocused && 'none',
      '&:focus-within': {
        border: '1px solid #ed3a7f',
        boxShadow: '0 0 0 3px rgba(255, 211, 198, 0.38)',
      },
      '&:invalid': {
        border: '1px solid green',
      },
    }),
  };

  // handleSelections
  const handleCity = (value) => {
    console.error('***HANDLE CITY***');
    setSelectedBuildingNumber(null);
    setSelectedStreetNumber(null);
    setSelectedStreet('');
    console.log("_155_ setSelectedCity", value);
    //setSelectedCity(value);
    setSelectedCity({ pk: value.pk, nome: value.nome, cod_comune_alfa: value.cod_comune_alfa, codiceIstat: value.cod_comune_alfa });

    setOrigData(null);
    setSelectedService(null);
    localStorage.removeItem(`SITE-${keyID}`);
    localStorage.removeItem(`SITE-SELECTED-${keyID}`);
    //console.log("removeItem", keyID );
  };

  const handleStreet = (value) => {
    console.error('***HANDLE STREET***');
    setSelectedBuildingNumber(null);
    setSelectedStreetNumber(null);
    console.log("_170_ setSelectedStreet", value);
    //setSelectedStreet(value);
    setSelectedStreet({ part_top: value.part_top, strada: value.strada, indirizzo: value.indirizzo, codiceEgon: '' });

    setOrigData(null);
    setSelectedService(null);
    localStorage.removeItem(`SITE-${keyID}`);
    localStorage.removeItem(`SITE-SELECTED-${keyID}`);
    //console.log("removeItem", keyID );
  };

  const handleStreetNumber = (value) => {
    console.error('***HANDLE STREET NUMBER***');
    setSelectedBuildingNumber(null);
    setSelectedStreetNumber(value);

    setOrigData(null);
    setSelectedService(null);
    localStorage.removeItem(`SITE-${keyID}`);
    localStorage.removeItem(`SITE-SELECTED-${keyID}`);
    //console.log("removeItem", keyID );
  };

  const handleBuildingNumber = (value) => {
    console.error('***HANDLE BUILDING NUMBER***');
    setSelectedBuildingNumber(value);

    setOrigData(null);
    setSelectedService(null);
    localStorage.removeItem(`SITE-${keyID}`);
    localStorage.removeItem(`SITE-SELECTED-${keyID}`);
    //console.log("removeItem", keyID );
  };

  const debounceTimeout = 666;

  const loadMunicipality_delayed = (value, callback) => {
    //console.log('loadMunicipality_delayed',value);
    if (debounceMunicipality) clearTimeout(debounceMunicipality);
    if (value) debounceMunicipality = setTimeout(() => { loadMunicipality(value, callback); }, debounceTimeout);
  }

  const loadStreets_delayed = (value, callback) => {
    //console.log('loadStreets_delayed',value);
    if (debounceStreets) clearTimeout(debounceStreets);
    if (value) debounceStreets = setTimeout(() => { loadStreets(value, callback); }, debounceTimeout);
  }

  const loadMunicipality = (inputValue, callback) => {
    console.error('***LOAD MUNICIPALITY***');
    //clearTimeout(debounceMunicipality);
    //console.log('loadMunicipality',inputValue);
    if (inputValue.length >= ConfigHandler.getConfig().defaults.minInputLength) {
      return Utils.handleInputSearch(inputValue).then((text) => {
        return RestService.get({
          //url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.getMunicipality}?q=${text}`,
          url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.vayuComuni}?q=${text}`,
          showLoader: false
        }).then((response) =>
          response.json()
            .then((data) => ({ data }))
            .then((res) => {
              if (response.status == 200) {
                console.error('***LOAD MUNICIPALITY - RES***');
                callback(res.data);
                return res.data;
              } else {
                setErrorMessage(true);
                return []
              }
            }),
        )
      });
    }
  };

  const loadStreets = (inputValue, callback) => {
    console.error('***LOAD STREETS***');
    //clearTimeout(debounceStreets);
    //console.log('loadStreets',inputValue);
    if (inputValue.length >= ConfigHandler.getConfig().defaults.minInputLength) {
      if (selectedCity != null) {
        return Utils.handleInputSearch(inputValue).then((text) => {
          return RestService.get({
            //url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.getStreet}?istatCode=${selectedCity.codiceIstat}&q=${inputValue}`,
            url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.vayuIndirizzi}?pkCode=${selectedCity.pk}&q=${inputValue}`,
            showLoader: false
          }).then((response) =>
            response.json()
              .then((data) => ({ data, }))
              .then((res) => {
                if (response.status == 200) {
                  console.error('***LOAD STREETS - RES***');
                  callback(res.data);
                  return res.data;
                } else {
                  setErrorMessage(true);
                  return []
                }
              }),
          );
        });
      }
    }
  };

  const loadStreetNumber = (inputValue, callback) => {
    console.error('***LOAD STREET NUMBER***');
    //console.log('loadStreetNumber',inputValue);
    if (selectedCity != null) {
      return RestService.get({
        //url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.getStreetNumber}?istatCode=${selectedCity.codiceIstat}&egonCode=${selectedStreet.codiceEgon}&q=${inputValue}`,
        url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.vayuCivici}?pkCode=${selectedCity.pk}&indirizzo=${selectedStreet.indirizzo}&q=${inputValue ? inputValue : "*"}`,
        showLoader: false
      }).then((response) =>
        response.json()
          .then((data) => ({ data, }))
          .then((res) => {
            if (response.status == 200) {
              console.error('***LOAD STREET NUMBER - RES***');
              if (inputValue != '') res.data = res.data.filter((item) => { return item.civico.startsWith(inputValue); });
              callback(res.data);
              return res.data;
            } else {
              setErrorMessage(true);
              return []
            }
          }),
      );
    }
  };

  const loadBuildingNumber = (inputValue, callback) => {
    console.error('***LOAD BUILDING NUMBER***');
    //console.log('loadBuildingNumber',inputValue);
    setHasBuildingNumbers(false);
    if (selectedStreetNumber != null) {
      return RestService.get({
        //url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.getBuildingNumber}?istatCode=${selectedCity.codiceIstat}&egonCode=${selectedStreet.codiceEgon}&streetNumber=${selectedStreetNumber.civico}&q=${inputValue}`,
        url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.vayuScale}?codIstat=${selectedCity.cod_comune_alfa}&partTop=${selectedStreet.part_top}&indirizzo=${selectedStreet.strada}&civico=${selectedStreetNumber.civico}&q=${inputValue}`,
        showLoader: false
      }).then((response) =>
        response.json()
          .then((data) => ({ data, }))
          .then((res) => {
            if (response.status == 200) {
              res.data = res.data.filter((item) => { return item.scala.startsWith(inputValue); });
              setHasBuildingNumbers(res.data.length > 0);
              callback(res.data);
              return res.data;
            } else {
              setErrorMessage(true);
              return []
            }
          }),
      );
    }
  };

  const threeLevels = (data) => {
    return data.map(item => {
      const updatedListino = item.listino.map(listItem => {
        const currLevel = listItem.level || [];
        while (currLevel.length < 3) currLevel.push(``);
        return { ...listItem, level: currLevel };
      });
      return { ...item, listino: updatedListino };
    });
  };

  const HandleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false || selectedCity === null || selectedStreet === null) {
      event.stopPropagation();
      setValidated(false);
      setOrigData(null);
      setListData(null);
      return null;
    }

    setActiveFilters({ level1: [], level2: [] });
    setLevelTouched({ level1: false, level2: false });
    setValidated(true);
    setTableParams({
      comune: selectedCity?.nome, istat: selectedCity?.codiceIstat, pk: selectedCity?.pk,
      part_top: selectedStreet?.part_top, strada: selectedStreet?.strada, egon: selectedStreet?.codiceEgon,
      civico: selectedStreetNumber?.civico, scala: selectedBuildingNumber?.scala
    });
    console.log("QuoteSite _352_", tableParams);

    let restCmd = `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.vayuCoverage}?`;
    if (!!selectedCity && !!selectedCity.cod_comune_alfa) restCmd += `codIstat=${selectedCity.cod_comune_alfa}&`;
    if (!!selectedCity && !!selectedCity.nome) restCmd += `comune=${selectedCity.nome}&`;
    if (!!selectedStreet && !!selectedStreet.part_top) restCmd += `partTop=${selectedStreet.part_top}&`;
    if (!!selectedStreet && !!selectedStreet.strada) restCmd += `indirizzo=${selectedStreet.strada}&`;
    if (!!selectedStreetNumber && !!selectedStreetNumber.civico) restCmd += `civico=${selectedStreetNumber.civico}&`;
    if (!!selectedBuildingNumber && !!selectedBuildingNumber.scala) restCmd += `scala=${encodeURIComponent(selectedBuildingNumber.scala)}&`;
    if (!!partner && !!partner.id) restCmd += `partnerId=${partner.id}&`;

    console.log(restCmd);
    RestService.get({ url: restCmd }).then((response) =>
      response.json()
        .then((data) => ({ data: data, }))
        .then((res) => {
          dataReturn = threeLevels(res.data.servizi);
          console.log("origData", dataReturn);
          setOrigData(dataReturn);
        }),
    );

    localStorage.setItem(`SITE-${keyID}`, JSON.stringify({ SITE: keyID, istat: selectedCity.cod_comune_alfa }));
    //console.log("setItem", keyID );
  };

  const options = [
    {
      label: 'Address',
      value: 'address',
      selectedBackgroundColor: '#fee8e6',
      selectedFontColor: '#ff6033',
    },
    {
      label: 'Coordinates',
      value: 'coordinates',
      selectedBackgroundColor: '#fee8e6',
      selectedFontColor: '#ff6033',
    },
  ];

  const initialSelectedIndex = options.findIndex(({ value }) => value === 'address');

  const onChange = (newValue) => {
    setLocationMethod(newValue);
  };

  const resetFields = () => {
    setActiveFilters({ level1: [], level2: [] });
    setLevelTouched({ level1: false, level2: false });
    setSelectedStreet(null);
    setSelectedCity(null);
    setSelectedStreetNumber(null);
    setSelectedBuildingNumber(null);
    setOrigData(null);
    setListData(null);
    setSelectedService(null);
    localStorage.removeItem(`SITE-${keyID}`);
    localStorage.removeItem(`SITE-SELECTED-${keyID}`);
    //console.log("removeItem", keyID );
  }

  console.log("QuoteSite _413_", tableParams);
  return (
    <Container fluid className='my-3 quoteSiteContainer'>
      <Row>
        <Row className='heading' style={{ margin: 'auto' }}>
          <Col md={3} sm={12} className="left">
            <div className='siteHeadingTitle'>
              {(keyID > 0) && (
                <div className="iconBox" onClick={() => { removeSite(keyID) }}>
                  {view === false && (<Icon>delete</Icon>)}
                </div>
              )}
              <div>
                SITE {keyID + 1}
              </div>
            </div>
          </Col>
          <Col md={6} className="middle item-center">
            {(selectedService != null) && (
              <>
                <Icon className='fadedText'>assignment_turned_in</Icon> <b style={{ verticalAlign: 'top' }}>{selectedService}</b>
              </>
            )}
          </Col>
          <Col md={3} className="right">
            <div className='siteHeadingAdd' onClick={() => { addSite() }}>
              {(view == false) && (
                <div className='iconBox'>
                  <Icon>add</Icon>
                </div>
              )}
              <div className='textBox'>
                {t('NEWQUOTE.SITE.AddSiteLabel')}
              </div>
            </div>
          </Col>
        </Row>
        <Row className='content pb-3' style={{ margin: 'auto' }}>
          {(isLoadingContent) && (
            <div className='isLoading item-center'>
              <Spinner animation="grow" variant="light" />
            </div>
          )}
          <Col md={12} className="px-1 py-3">
            <Row className='my-2'>
              <Col md={12}>
                {((partner != null) && (AuthHandler.getUserData().role == 'ADMIN')) && (
                  <Badge bg="danger" style={{ width: '100%' }}>* Coverage informations with Custom Pricebook of <b>{partner?.name}</b></Badge>
                )}
              </Col>
            </Row>
            <Form noValidate validated={validated} onSubmit={HandleSubmit} className="AdminNewUSer" id="coverageParams-form">
              <Row className='p-1'>
                <Form.Group as={Col} md={3} controlId="CitySelection" >
                  <p className='label-form'>{t('FORMS.City')}</p>
                  <AsyncSelect
                    className="AdminNewUSer__AsyncSelect_Company"
                    cacheOptions
                    //defaultValue=''
                    //isClearable
                    value={selectedCity}
                    noOptionsMessage={() => t('OTHERS.Min3CharLabel')}
                    loadOptions={loadMunicipality_delayed}
                    onChange={handleCity}
                    getOptionLabel={(e) => e.nome}
                    getOptionValue={(e) => e.pk}
                    styles={customStyles}
                    placeholder={t('NEWQUOTE.SITE.SelectCity')}
                    isDisabled={view ? true : false}
                  />
                </Form.Group>
                <Form.Group as={Col} md={4} controlId="StreetSelection">
                  <p className='label-form'>{t('FORMS.Street')}</p>
                  <AsyncSelect
                    className="AdminNewUSer__AsyncSelect_Company"
                    cacheOptions
                    //defaultValue=''
                    //isClearable
                    noOptionsMessage={() => t('OTHERS.Min3CharLabel')}
                    value={selectedStreet}
                    loadOptions={loadStreets_delayed}
                    onChange={handleStreet}
                    getOptionLabel={(e) => e.indirizzo}
                    getOptionValue={(e) => e.indirizzo}
                    styles={customStyles}
                    placeholder={t('NEWQUOTE.SITE.SelectStreet')}
                    isDisabled={!selectedCity || view === true ? true : false}
                  />
                </Form.Group>
                <Form.Group as={Col} md={2} controlId="StreetNumber">
                  <p className='label-form'>{t('FORMS.StreetNumLabel')}</p>
                  <AsyncSelect
                    className="AdminNewUSer__AsyncSelect_Company"
                    cacheOptions
                    //defaultValue=''
                    //isClearable
                    //key={selectedStreet == null ? 'key_StreetNumber' : selectedStreet.codiceIstat}
                    key={!selectedStreet ? null : 'key_Street_' + selectedStreet.indirizzo}
                    defaultOptions
                    noOptionsMessage={() => t('OTHERS.MinCharLabel')}
                    value={selectedStreetNumber}
                    loadOptions={loadStreetNumber}
                    onChange={handleStreetNumber}
                    getOptionLabel={(e) => e.civico}
                    getOptionValue={(e) => e.civico}
                    styles={customStyles}
                    classNamePrefix="asyncselect"
                    placeholder={t('NEWQUOTE.SITE.SelectStreetNumber')}
                    isDisabled={!selectedStreet || view === true ? true : false}
                  />
                </Form.Group>
                <Form.Group as={Col} md={2} controlId="BuildingNumber">
                  <p className='label-form'>{t('FORMS.BuildingNumberLabel')}</p>
                  <AsyncSelect
                    className="AdminNewUSer__AsyncSelect_Company"
                    cacheOptions
                    //defaultValue=''
                    //isClearable
                    //key={selectedStreetNumber == null ? 'key_BuildingNumber' : selectedStreetNumber}
                    key={!selectedStreetNumber ? null : 'key_StreetNumber_' + selectedStreetNumber.civico}
                    defaultOptions
                    noOptionsMessage={() => t('OTHERS.NoDataMessage')}
                    value={selectedBuildingNumber}
                    loadOptions={loadBuildingNumber}
                    onChange={handleBuildingNumber}
                    getOptionLabel={(e) => e.scala}
                    getOptionValue={(e) => e.scala}
                    classNamePrefix="asyncselect"
                    styles={customStyles}
                    placeholder={t('NEWQUOTE.SITE.SelectBuildingNumber')}
                    isDisabled={(!selectedStreetNumber) || (!hasBuildingNumbers) || view === true ? true : false}
                  />
                </Form.Group>
                <Form.Group as={Col} md={1} className="item-center">
                  <p className='label-form'><br /></p>
                  {
                    (
                      (selectedStreetNumber != null && selectedStreet && (!hasBuildingNumbers))
                      ||
                      (selectedStreetNumber != null && selectedStreet && hasBuildingNumbers && selectedBuildingNumber)
                    )
                    &&
                    (
                      <Button id={`searchBut-${keyID}`} type="submit" className="m-0 p-0 btn btn-sm searchButton"><img src={Search} /></Button>
                    )
                  }
                  <Button id={`resetBut-${keyID}`} onClick={() => resetFields()} className="m-0 p-0 btn btn-sm searchButton"><img src={Close} /></Button>
                </Form.Group>
              </Row>
            </Form>
          </Col>
          {((origLevels != null) && (origData != null) && (origData.length > 0)) && (
            <>
              <Row>
                <Col className="item-center">
                  {(origLevels != null) && (activeFilters?.level1?.length > 0) && (activeFilters?.level2?.length > 0) && (
                    <>
                      <Form>
                        <Row className="item-center align-items-start">
                          <Col xs="auto" className="">
                            {origLevels?.[1].map((level, index) => (
                              <Form.Check className="text-start"
                                type="switch"
                                id={`custom-switch-${index}`}
                                key={index}
                                label={level}
                                checked={activeFilters.level1.includes(level) && (levelTouched.level1)}
                                onChange={() => toggleFilter('level1', level)}
                              />
                            ))}
                          </Col>
                          <Col xs="auto" className='mx-5'><h4>Filtra i servizi disponibili</h4></Col>
                          <Col xs="auto">
                            {origLevels?.[2].map((level, index) => (
                              <Form.Check className="text-start"
                                type="switch"
                                id={`custom-switch-${index}`}
                                key={index}
                                label={level}
                                checked={activeFilters.level2.includes(level) && (levelTouched.level2)}
                                onChange={() => toggleFilter('level2', level)}
                              />
                            ))}
                          </Col>
                        </Row>

                        {/* {origLevels[1].map((level, index) => (
                        <Button key={index} className="m-1" onClick={() => toggleFilter('level1', level)} variant={activeFilters.level1.includes(level) ? "info" : "outline-info"} >{level}</Button>
                      ))} */}
                        {/* {origLevels[2].map((level, index) => (
                        <Button key={index} className="m-1" onClick={() => toggleFilter('level2', level)} variant={activeFilters.level2.includes(level) ? "warning" : "outline-warning"} >{level}</Button>
                      ))} */}
                      </Form>
                    </>
                  )}
                </Col>
              </Row>
            </>
          )}
          <Row>
            {((listData != null) && (listData.length > 0)) ? (
              <QuoteCoverageTable
                istat={tableParams?.istat}
                //egon={tableParams?.egon}
                egon={tableParams?.pk}
                city={tableParams?.comune}
                particellaToponomastica={tableParams?.part_top}
                street={tableParams?.strada}
                snumber={tableParams?.civico}
                bnumber={tableParams?.scala}
                data={listData}
                keyID={keyID}
                calculateTotal={calculateTotal}
                editingMode={editingMode}
                serviceID={editingMode === true && datas != undefined ? datas : null}
                view={view}
                quoteID={quoteID}
                partner={partner}
                setSelectedService={setSelectedService}
                setIsLoadingContent={setIsLoadingContent}
                key={`QuoteCoverageTable-${keyID}`}
              />
            ) : (
              <Col className="item-center">{validated ? <p>{t('NEWQUOTE.COVERAGE.NoServices')}</p> : null}</Col>
            )}
          </Row>
        </Row>
      </Row>
    </Container>
  );
};

export default QuoteSite;
